/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  UniV3LoanRouter,
  UniV3LoanRouterInterface,
} from "../UniV3LoanRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISwapRouter",
        name: "_uniswapV3Router",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "MAX_UINT256",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "sales",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "borrowMax",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Router",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "underlyingAmount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "sales",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "underlyingAmount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrowMax",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniV3LoanRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniV3LoanRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniV3LoanRouter__factory extends ContractFactory {
  constructor(...args: UniV3LoanRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _uniswapV3Router: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<UniV3LoanRouter> {
    return super.deploy(
      _uniswapV3Router,
      overrides || {}
    ) as Promise<UniV3LoanRouter>;
  }
  override getDeployTransaction(
    _uniswapV3Router: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_uniswapV3Router, overrides || {});
  }
  override attach(address: string): UniV3LoanRouter {
    return super.attach(address) as UniV3LoanRouter;
  }
  override connect(signer: Signer): UniV3LoanRouter__factory {
    return super.connect(signer) as UniV3LoanRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniV3LoanRouterInterface {
    return new utils.Interface(_abi) as UniV3LoanRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniV3LoanRouter {
    return new Contract(address, _abi, signerOrProvider) as UniV3LoanRouter;
  }
}
